<div class="container margin-top-1 pb-5">
  <div class="row pt-4">
    <div class="col-md-12 card p-3">
      <div class="row">
        <div class="col-md-6">
          <h1 class="pb-4 primary bold">
            <i class="fas fa-users"></i> {{ "benefit-premium-title-1" | translate }} 
          </h1>
        </div>
        <!-- <div class="col-md-6">
          <a
            class="search-teacher-button float-right"
            [routerLink]="['/search/teacher']"
          >
            <i class="fas fa-search"></i> 
          </a>
        </div> -->
      </div>

      <!-- START Listado desktop -->
      <div class="desktop" *ngIf="!isMobile">
        <form [formGroup]="filters">
          <div class="row m-1 filters-box">
            <div class="col-md-3">
              <p class="text-center bold primary">{{ "subject-or-language" | translate }} </p>
          
              <select
                formControlName="lesson_id"
                class="select-groupal-filter"
                style="max-width: 100%"
                (change)="getGrupalClassesFiltered()"
              >
                <option                  
                  [value]='0'
                  [selected]="active_filters['lesson_id']=='0'"
                  
                >Todos</option>
                <option *ngFor="let lesson of lessons" [value]="lesson.lesson.id" [selected]="lesson.lesson.id===active_filters['lesson_id']">
                  {{ lesson.lesson.name }} - <span *ngIf="lesson.lesson_level">{{ lesson.lesson_level.name }}</span>
                </option>
              </select>
           
            </div>
            <div class="col-md-3">
              <p class="text-center bold primary"> {{ "from-date" | translate }}</p>
              <div class="text-center">
                <input 
                  formControlName="date_start"
                  (change)="getGrupalClassesFiltered()"
                  [value]="active_filters['date_start']"
                  type="date" class="input-date-select" />
              </div>
            </div>
            <div class="col-md-3">
              <p class="text-center bold primary">{{ "to-date" | translate }}</p>
              <div class="text-center">
                <input
                    formControlName="date_end"
                    (change)="getGrupalClassesFiltered()"
                    [value]="active_filters['date_end']"
                    type="date" class="input-date-select" />
              </div>
            </div>
            <div class="col-md-3">
              <p class="text-center bold primary">{{ "class-language" | translate }} </p>
              <div class="text-center">
                <select
                   formControlName="language_id"
                   (change)="getGrupalClassesFiltered()"
                   class="select-groupal-filter">
                   <option [value]="0">Todos</option>
                  <option
                    *ngFor="let language of languages"
                    [value]="language.language.id"
                    [selected]="language.language.id===active_filters['language_id']"
                  >
                    {{ language.language.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </form>
        <div class="row m-1 pt-4">
          <div class="table-responsive mt-3">
            <table class="table">
              <thead class="primary bold">
                <tr>
                  <th scope="col" class="headers-table">{{ "date" | translate }} </th>
                  <th scope="col">{{ "hour" | translate }} </th>
                  <th scope="col">{{ "name" | translate }} </th>
                  <th scope="col">{{ "language" | translate }} </th>
                  <th scope="col">{{ "duration" | translate }} </th>
                  <th scope="col text-center">{{ "free-spaces" | translate }} </th>
                  <th scope="col">{{ "price" | translate }} </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <!-- START bucle listado clases -->
                <tr *ngFor="let class of listedClasses">
                  <td>
                    <strong>{{ class.date }}</strong>
                  </td>
                  <td>{{ class.hour }} h.</td>

                  <td>
                    <strong>{{ class.name }}</strong>
                    <br/>
                    <span class="small" *ngIf="class.lesson_level">{{ class.lesson.name }} - {{ class.lesson_level.name }}</span>
                    <span class="small" *ngIf="!class.lesson_level">{{ class.lesson.name }}</span>
                  </td>
                  <td class="">{{ class.language.name }}</td>

                  <td class="">{{ class.duration }} h.</td>
                  <td class="text-center">{{ class.freePlaces }}</td>
                  <td>{{ class.price | currency : "EUR" : true }}</td>
                  <td>
                    <i
                      class="far fa-eye"
                      alt="Ver más detalles"
                      title="Ver más detalles"
                      style="cursor: pointer"
                      [routerLink]="[
                        '/student/group-classes/class-detail/',
                        class.id
                      ]"
                    ></i>
                  </td>
                </tr>
                <!-- START bucle listado clases -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- END Listado desktop -->


    </div>
  </div>
</div>
